import React from 'react';
import Header from './app/Header';
import Footer from './app/Footer';
import FooterCopyright from './app/FooterCopyright';

// =================================================================
// AVISO INTERNO (não aparece na página): este é um modelo robusto
// de Termos de Uso para plataforma de intermediação tecnológica,
// desenhado para Buzaym Marketing Digital LTDA — Fretz.
// Recomendamos revisão por advogado especializado em direito digital
// e direito do consumidor antes da publicação definitiva.
// =================================================================

const P = ({ children }) => (
  <p className="text-ink-700 leading-relaxed mt-3">{children}</p>
);
const Li = ({ children }) => (
  <li className="text-ink-700 leading-relaxed">{children}</li>
);

const sections = [
  {
    id: 'definicoes',
    title: '1. Definições',
    render: () => (
      <>
        <P>Para os fins destes Termos, adotam-se as seguintes definições, que se aplicam tanto no singular quanto no plural:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li><strong>FRETZ</strong> ou <strong>PLATAFORMA</strong>: solução tecnológica de intermediação e promoção de vendas, disponibilizada via web e aplicativos, de titularidade da <strong>BUZAYM MARKETING DIGITAL LTDA</strong>, sociedade empresária inscrita no CNPJ sob o nº 49.130.988/0001-00, com sede em Goiânia/GO, cuja atividade principal é a intermediação tecnológica e promoção de vendas (CNAE 73.19-0/02 e correlatos).</Li>
          <Li><strong>CLIENTE</strong>: pessoa jurídica (ou empresário) que contrata um plano Fretz Empresas para coletas e entregas de sacolas/pacotes na Grande Goiânia.</Li>
          <Li><strong>MOTORISTA DE ROTA</strong>: profissional que executa os circuitos da frota identificada Fretz, na forma do contrato específico aceito no cadastro.</Li>
          <Li><strong>USUÁRIO</strong>: termo genérico que designa o CLIENTE e o MOTORISTA DE ROTA.</Li>
          <Li><strong>PLANO</strong>: assinatura mensal Diário, Semanal ou Mensal, com paradas inclusas e cobrança de extras por parada excedente.</Li>
          <Li><strong>PARADA</strong>: cada ponto em que o veículo Fretz para para coletar ou entregar.</Li>
          <Li><strong>PEDIDO</strong>: solicitação de coleta/entrega vinculada ao PLANO do CLIENTE.</Li>
        </ol>
      </>
    ),
  },
  {
    id: 'natureza',
    title: '2. Natureza jurídica e limitação funcional da FRETZ',
    render: () => (
      <>
        <P>2.1. A FRETZ oferece o serviço <strong>Fretz Empresas</strong>: planos mensais de rota compartilhada, com veículos identificados da marca, para transporte de sacolas e pacotes na Grande Goiânia.</P>
        <P>2.2. O serviço <strong>não inclui</strong> mudanças, móveis, eletrodomésticos, cargas de caminhão, picape avulsa nem marketplace de motoristas independentes para esses fins.</P>
        <P>2.3. Dimensões e peso máximos: <strong>40×40×40 cm e 8 kg</strong> por volume. Volumes fora do limite poderão ser recusados.</P>
        <P>2.4. A FRETZ poderá, a seu critério, oferecer canais de atendimento para intercorrências operacionais, sem prejuízo das limitações da seção 11.</P>
      </>
    ),
  },
  {
    id: 'aceitacao',
    title: '3. Aceitação destes Termos',
    render: () => (
      <>
        <P>3.1. Ao se cadastrar na PLATAFORMA, ao confirmar um PEDIDO ou ao utilizar qualquer funcionalidade da FRETZ, o USUÁRIO declara que <strong>leu, compreendeu e aceitou integralmente</strong> estes Termos, a Política de Privacidade e, no caso do ENTREGADOR PARCEIRO, o Contrato de Intermediação de Serviços.</P>
        <P>3.2. Caso o USUÁRIO não concorde, ainda que parcialmente, com qualquer disposição destes Termos, deverá <strong>abster-se imediatamente</strong> de utilizar a PLATAFORMA.</P>
        <P>3.3. O CLIENTE pessoa natural deverá ter, no mínimo, 18 anos de idade ou ser plenamente capaz nos termos da legislação civil. O ENTREGADOR PARCEIRO deverá ser maior de 18 anos, possuir habilitação válida compatível e cumprir os requisitos do Contrato de Intermediação.</P>
      </>
    ),
  },
  {
    id: 'cadastro',
    title: '4. Cadastro de conta',
    render: () => (
      <>
        <P>4.1. O cadastro depende do fornecimento de informações verídicas, completas e atualizadas. O USUÁRIO é o único responsável pela veracidade dos dados fornecidos.</P>
        <P>4.2. O USUÁRIO compromete-se a manter sob sigilo absoluto suas credenciais de acesso, sendo o único e exclusivo responsável por qualquer atividade realizada em sua conta, ainda que por terceiros.</P>
        <P>4.3. A FRETZ poderá, a seu critério, recusar cadastros, exigir documentação adicional, validar dados perante bases públicas e privadas e suspender ou excluir contas que violem estes Termos.</P>
      </>
    ),
  },
  {
    id: 'contratacao',
    title: '5. Contratação dos serviços',
    render: () => (
      <>
        <P>5.1. Ao assinar um PLANO, o CLIENTE contrata a FRETZ para coletas e entregas de sacolas e pacotes na Grande Goiânia, no ritmo do plano escolhido (Diário, Semanal ou Mensal).</P>
        <P>5.2. Os preços vigentes são os publicados em fretz.com.br/precos: Plano Diário R$ 1.890/mês (60 paradas, extra R$ 35, SLA de 36 horas após a coleta); Plano Semanal R$ 790/mês (24 paradas, extra R$ 38, SLA de 72 horas úteis após a coleta da semana); Plano Mensal R$ 290/mês (8 paradas, extra R$ 45, SLA de 72 horas úteis após a coleta).</P>
        <P>5.3. Coleta Diário ocorre em dias úteis, na rota compartilhada. Coleta Semanal ocorre 1 (uma) vez por semana, em dia fixo, em uma única rota naquele dia. Coleta Mensal ocorre 1 (uma) vez por mês, em janela agendada, encaixada em um dia de rota.</P>
        <P>5.4. <strong>Regra da porta</strong>: o veículo Fretz estaciona nas proximidades. O CLIENTE (ou destinatário) deve encontrar o veículo em até <strong>15 (quinze) minutos</strong>. Esgotado o prazo, a rota segue e a parada poderá ser considerada frustrada, sem prejuízo da contagem da parada ou da cobrança de nova tentativa, conforme o caso.</P>
      </>
    ),
  },
  {
    id: 'pagamento',
    title: '6. Pagamento',
    render: () => (
      <>
        <P>6.1. O pagamento do PLANO é mensal, na forma combinada na contratação (Pix, cartão ou faturamento), em moeda corrente nacional.</P>
        <P>6.2. Paradas além das inclusas no PLANO são cobradas no fechamento do mês, pelo valor de extra do respectivo plano.</P>
        <P>6.3. Eventuais reembolsos serão analisados caso a caso. Não há simulador de frete avulso de picape ou mudança.</P>
      </>
    ),
  },
  {
    id: 'itens-proibidos',
    title: '7. Itens proibidos',
    render: () => (
      <>
        <P>7.1. É <strong>terminantemente proibido</strong> utilizar a PLATAFORMA para o transporte de:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>armas de qualquer natureza, munições e materiais explosivos;</Li>
          <Li>entorpecentes, substâncias psicotrópicas ou produtos cujo comércio dependa de receita controlada, sem documentação legal;</Li>
          <Li>materiais inflamáveis, corrosivos, radioativos, biológicos ou perigosos sob a Resolução ANTT vigente;</Li>
          <Li>seres humanos, animais vivos, partes ou tecidos humanos ou animais;</Li>
          <Li>produtos perecíveis sem acondicionamento adequado, alimentos preparados sem licença sanitária, medicamentos sem documentação;</Li>
          <Li>moeda em espécie, metais preciosos, joias, obras de arte, instrumentos negociáveis, documentos de identidade originais e bens cuja perda seja substancialmente irreparável;</Li>
          <Li>itens cujo valor declarado exceda <strong>R$ 500,00</strong> (quinhentos reais);</Li>
          <Li>itens ilícitos, contrafeitos, falsificados, sem nota fiscal quando exigida ou que violem direitos de propriedade intelectual;</Li>
          <Li>quaisquer outros itens cuja circulação dependa de licenças, autorizações ou condições especiais não atendidas.</Li>
        </ol>
        <P>7.2. O CLIENTE é o <strong>único responsável</strong> pelo conteúdo da encomenda, declarando, ao confirmar o PEDIDO, que ela respeita as restrições acima e a legislação aplicável.</P>
        <P>7.3. A FRETZ e o ENTREGADOR PARCEIRO poderão recusar, abrir ou descartar encomendas que violem estes Termos, sem direito a reembolso.</P>
      </>
    ),
  },
  {
    id: 'obrigacoes-cliente',
    title: '8. Obrigações e responsabilidades do CLIENTE',
    render: () => (
      <>
        <P>8.1. Compete ao CLIENTE:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>fornecer endereços completos e corretos de coleta e entrega;</Li>
          <Li>acondicionar adequadamente a encomenda, sob sua exclusiva responsabilidade;</Li>
          <Li>declarar, com boa-fé e veracidade, o conteúdo e o valor da encomenda;</Li>
          <Li>estar disponível, ou ter pessoa autorizada disponível, para encontrar o veículo Fretz em até 15 minutos na coleta e na entrega;</Li>
          <Li>tratar o ENTREGADOR PARCEIRO com civilidade e respeito, abstendo-se de assédio, discriminação e violência;</Li>
          <Li>arcar com os custos integrais de PEDIDOS confirmados, ressalvadas as hipóteses de reembolso da seção 6.</Li>
        </ol>
        <P>8.2. O CLIENTE responde, em caráter exclusivo, por danos causados a terceiros, ao ENTREGADOR PARCEIRO ou à FRETZ em razão de informações inexatas ou de descumprimento das obrigações desta cláusula.</P>
      </>
    ),
  },
  {
    id: 'obrigacoes-entregador',
    title: '9. Obrigações e responsabilidades do ENTREGADOR PARCEIRO',
    render: () => (
      <>
        <P>9.1. O ENTREGADOR PARCEIRO atua na PLATAFORMA como <strong>profissional autônomo</strong>, em nome próprio e sob seu exclusivo risco operacional, sendo o único responsável por:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>manter sua habilitação, documentação pessoal, do veículo e licenças exigidas pela legislação válidas e regulares;</Li>
          <Li>cumprir as normas de trânsito e segurança pública;</Li>
          <Li>responder por avarias, extravios, atrasos e demais ocorrências durante a posse da encomenda, observado o limite contratual descrito na seção 11;</Li>
          <Li>recolher integralmente os tributos, contribuições previdenciárias e demais encargos decorrentes da sua atividade autônoma;</Li>
          <Li>tratar o CLIENTE com civilidade, atender solicitações razoáveis e prestar informações verídicas sobre o status do PEDIDO.</Li>
        </ol>
        <P>9.2. As condições específicas da relação entre a FRETZ e o ENTREGADOR PARCEIRO estão disciplinadas no <strong>Contrato de Intermediação de Serviços</strong>, aceito ao cadastrar-se.</P>
      </>
    ),
  },
  {
    id: 'limitacao',
    title: '10. Limites de responsabilidade da FRETZ',
    render: () => (
      <>
        <P>10.1. A responsabilidade civil da FRETZ restringe-se ao serviço Fretz Empresas efetivamente contratado (planos de rota para sacolas e pacotes na Grande Goiânia), observados os limites destas seções.</P>
        <P>10.2. A FRETZ não responde, salvo nas hipóteses do art. 14 do Código de Defesa do Consumidor e demais normas cogentes:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>por atos, omissões ou condutas de USUÁRIOS;</Li>
          <Li>por avarias, extravios, atrasos ou furto da encomenda durante a execução do CONTRATO DE TRANSPORTE;</Li>
          <Li>por danos a terceiros causados pelo ENTREGADOR PARCEIRO no curso do transporte;</Li>
          <Li>por descumprimento de obrigações do CLIENTE quanto ao acondicionamento ou conteúdo da encomenda;</Li>
          <Li>por intercorrências de força maior, caso fortuito ou fato de terceiro (intempéries, bloqueios viários, manifestações, falhas em redes de telecomunicação, indisponibilidade de provedores de pagamento, mapa ou hospedagem);</Li>
          <Li>por inexecução resultante de informações imprecisas fornecidas pelo CLIENTE.</Li>
        </ol>
        <P>10.3. A PLATAFORMA é fornecida "no estado em que se encontra" e "conforme disponível". A FRETZ envida esforços razoáveis para mantê-la operacional, mas <strong>não garante disponibilidade ininterrupta</strong>, ausência de erros ou compatibilidade com todos os dispositivos.</P>
        <P>10.4. Em conformidade com o art. 51 do Código de Defesa do Consumidor, as disposições desta seção não excluem responsabilidade decorrente de dolo, culpa grave ou de defeito do próprio serviço de intermediação prestado pela FRETZ.</P>
      </>
    ),
  },
  {
    id: 'indenizacao-limitada',
    title: '11. Indenização contratual limitada',
    render: () => (
      <>
        <P>11.1. Em virtude da natureza do serviço (entregas urbanas de pequeno porte e baixo valor), as Partes convencionam livremente que o valor máximo de indenização contratual, a qualquer título, decorrente de avaria, extravio, perda ou furto da encomenda durante o CONTRATO DE TRANSPORTE será limitado a <strong>R$ 500,00 (quinhentos reais)</strong>, observados os termos abaixo.</P>
        <P>11.2. Para fazer jus à indenização, o CLIENTE deverá:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>comunicar a ocorrência à FRETZ por escrito, em até <strong>07 (sete) dias corridos</strong> contados da data prevista para a entrega;</Li>
          <Li>apresentar nota fiscal, recibo ou outro comprovante idôneo do valor declarado da encomenda;</Li>
          <Li>colaborar com a apuração dos fatos, inclusive registrando boletim de ocorrência quando aplicável.</Li>
        </ol>
        <P>11.3. O ressarcimento será efetuado preferencialmente pelo ENTREGADOR PARCEIRO, podendo a FRETZ adiantá-lo ao CLIENTE e, em seguida, descontar o valor da remuneração do ENTREGADOR PARCEIRO, sem prejuízo de ações de regresso cabíveis.</P>
        <P>11.4. Não há cobertura para itens proibidos (seção 7), itens não declarados, danos indiretos, lucros cessantes, danos morais não comprovados ou quaisquer prejuízos que excedam o valor declarado da encomenda.</P>
      </>
    ),
  },
  {
    id: 'cancelamento',
    title: '12. Cancelamento do PEDIDO',
    render: () => (
      <>
        <P>12.1. O CLIENTE poderá cancelar um PEDIDO, sem custo, antes da efetiva chegada do ENTREGADOR PARCEIRO ao ponto de coleta.</P>
        <P>12.2. Cancelamentos posteriores poderão gerar cobrança proporcional ao deslocamento já realizado, devida ao ENTREGADOR PARCEIRO.</P>
        <P>12.3. O ENTREGADOR PARCEIRO poderá recusar a continuidade do PEDIDO em caso de risco à integridade física, descumprimento destes Termos pelo CLIENTE ou suspeita razoável de itens proibidos.</P>
        <P>12.4. A FRETZ poderá cancelar PEDIDOS, devolvendo integralmente os valores pagos, em casos de suspeita de fraude, indisponibilidade técnica grave ou descumprimento destes Termos.</P>
      </>
    ),
  },
  {
    id: 'suspensao',
    title: '13. Suspensão e exclusão de conta',
    render: () => (
      <>
        <P>13.1. A FRETZ poderá, fundamentadamente e a seu critério, suspender ou excluir contas de USUÁRIOS que:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>infringirem estes Termos, a Política de Privacidade ou o Contrato de Intermediação;</Li>
          <Li>fornecerem informações falsas no cadastro;</Li>
          <Li>praticarem atos ilícitos, fraudes, assédio, discriminação ou violência contra qualquer pessoa relacionada à PLATAFORMA;</Li>
          <Li>utilizarem a PLATAFORMA para finalidades distintas das previstas;</Li>
          <Li>tiverem registro reiterado de avaliações negativas, cancelamentos sem justa causa ou descumprimento de PEDIDOS aceitos.</Li>
        </ol>
        <P>13.2. A suspensão ou exclusão não gera direito a indenização, observado o pagamento de valores legitimamente devidos até a data do encerramento.</P>
      </>
    ),
  },
  {
    id: 'indenizar-fretz',
    title: '14. Indenização à FRETZ pelo USUÁRIO',
    render: () => (
      <>
        <P>14.1. O USUÁRIO obriga-se a defender, indenizar e isentar a FRETZ, suas controladoras, controladas, sócios, empregados, prepostos e parceiros, contra toda e qualquer reclamação, ação, perda, dano, custa, despesa e honorários advocatícios decorrentes:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>do uso da PLATAFORMA em violação a estes Termos;</Li>
          <Li>do conteúdo de encomendas que infrinja a seção 7 (itens proibidos);</Li>
          <Li>de informações falsas, inexatas ou enganosas fornecidas no cadastro ou em qualquer PEDIDO;</Li>
          <Li>de atos próprios do USUÁRIO que causem dano a terceiros.</Li>
        </ol>
      </>
    ),
  },
  {
    id: 'propriedade',
    title: '15. Propriedade intelectual',
    render: () => (
      <>
        <P>15.1. A marca FRETZ, o logotipo, o domínio fretz.com.br, os layouts, os códigos-fonte e demais elementos da PLATAFORMA são de titularidade da BUZAYM MARKETING DIGITAL LTDA, protegidos pela legislação autoral e de propriedade industrial.</P>
        <P>15.2. O cadastro confere ao USUÁRIO licença pessoal, não exclusiva, intransferível e revogável de uso da PLATAFORMA, restrita à finalidade prevista nestes Termos.</P>
        <P>15.3. É vedado copiar, modificar, descompilar, fazer engenharia reversa, criar obras derivadas ou explorar comercialmente qualquer elemento da PLATAFORMA, sem autorização expressa.</P>
      </>
    ),
  },
  {
    id: 'modificacoes',
    title: '16. Modificações',
    render: () => (
      <>
        <P>16.1. A FRETZ poderá alterar estes Termos a qualquer tempo, sendo a versão atualizada publicada no endereço fretz.com.br/termos com indicação da data da última atualização.</P>
        <P>16.2. As alterações são vinculantes a partir da data de publicação, e o uso continuado da PLATAFORMA implica aceitação tácita. Em caso de divergência, o USUÁRIO deverá cessar a utilização.</P>
      </>
    ),
  },
  {
    id: 'comunicacoes',
    title: '17. Comunicações',
    render: () => (
      <>
        <P>17.1. As comunicações relativas a PEDIDOS, conta e suporte são realizadas pelos canais cadastrados (e-mail, WhatsApp, notificações na PLATAFORMA), considerando-se válidas para todos os efeitos legais.</P>
        <P>17.2. Reclamações poderão ser dirigidas a contato@fretz.com.br. Solicitações relativas à proteção de dados deverão ser direcionadas a privacidade@fretz.com.br.</P>
      </>
    ),
  },
  {
    id: 'gerais',
    title: '18. Disposições gerais',
    render: () => (
      <>
        <P>18.1. A eventual tolerância ao descumprimento de qualquer cláusula não importa em renúncia, novação ou alteração destes Termos.</P>
        <P>18.2. A nulidade ou inexequibilidade de uma cláusula não compromete a validade das demais, que permanecerão em pleno vigor.</P>
        <P>18.3. Estes Termos representam o acordo integral entre as Partes sobre seu objeto, prevalecendo sobre quaisquer entendimentos anteriores.</P>
      </>
    ),
  },
  {
    id: 'foro',
    title: '19. Foro e legislação aplicável',
    render: () => (
      <>
        <P>19.1. Estes Termos regem-se pela legislação brasileira.</P>
        <P>19.2. Fica eleito o foro da Comarca de Goiânia/GO para dirimir quaisquer controvérsias decorrentes destes Termos, com renúncia a qualquer outro, por mais privilegiado que seja, ressalvado o direito do CLIENTE consumidor de demandar no foro do seu domicílio, nos termos do art. 101, I, do CDC.</P>
      </>
    ),
  },
];

const Termos = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 bg-mesh-light opacity-60" aria-hidden="true" />
        <div className="relative container mx-auto px-4 lg:px-6 py-16 lg:py-24 max-w-3xl">
          <span className="badge-brand mb-5">Documento legal</span>
          <h1 className="font-display text-display-lg text-ink-900">Termos de Uso</h1>
          <p className="mt-3 text-ink-500">
            Vigentes a partir de 19 de setembro de 2026 · Versão 3.0
          </p>

          <div className="mt-8 p-5 rounded-2xl bg-brand-50 border border-brand-100">
            <p className="text-sm text-ink-700 leading-relaxed">
              <strong>Resumo executivo</strong>: a FRETZ (Buzaym Marketing Digital LTDA)
              oferece o serviço B2B <strong>Fretz Empresas</strong> — planos mensais de
              rota compartilhada na Grande Goiânia (Diário, Semanal e Mensal),
              com frota identificada. O objeto é o transporte de sacolas e pacotes
              de até 40×40×40 cm e 8 kg. O CLIENTE deve encontrar o veículo em até
              15 minutos; esgotado o prazo, a rota segue. Não há marketplace de
              picape, mudança ou caminhão. Foro: Goiânia/GO.
            </p>
          </div>

          <div className="mt-10 space-y-10">
            {sections.map((s) => (
              <section key={s.id} id={s.id}>
                <h2 className="font-display text-xl font-bold text-ink-900">{s.title}</h2>
                {s.render()}
              </section>
            ))}
          </div>

          <div className="mt-12 p-6 rounded-2xl bg-ink-50 border border-ink-100">
            <p className="text-sm text-ink-600 leading-relaxed">
              <strong>BUZAYM MARKETING DIGITAL LTDA</strong> · CNPJ 49.130.988/0001-00<br />
              Goiânia/GO · contato@fretz.com.br · privacidade@fretz.com.br
            </p>
          </div>
        </div>
      </section>

      <Footer />
      <FooterCopyright />
    </div>
  );
};

export default Termos;
